module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0090.jpg?v=59b8d819";